var buildParams = function (searchQueries) {
    var searchParams = [];
    if (!searchQueries) {
        return searchParams;
    }
    // Take state object and make it into a query array
    for (var key in searchQueries) {
        if (key && searchQueries[key]) {
            searchParams.push({
                key: key,
                value: searchQueries[key],
            });
        }
    }
    return searchParams;
};
export default buildParams;
